/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IDynScriptInjectorData } from './dyn-script-injector.data';
import { IDynScriptInjectorProps } from './dyn-script-injector.props.autogenerated';

export interface IDynScriptInjectorViewProps extends IDynScriptInjectorProps<IDynScriptInjectorData> {}

/**
 *
 * DynScriptInjector component
 * @extends {React.PureComponent<IDynScriptInjectorProps<IDynScriptInjectorData>>}
 */
class DynScriptInjector extends React.PureComponent<IDynScriptInjectorProps<IDynScriptInjectorData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default DynScriptInjector;
